module.exports = __webpack_public_path__ + "img/de.671e95ae.svg";